<template>
  <v-row no-gutters class="d-flex flex-row justify-center fill-height">
    <v-col
      v-if="firstAccess && $vuetify.breakpoint.mdAndUp && !creatingAccount"
      cols="12"
      md="6"
      sm="12"
    >
      <!-- confirm email background -->
      <v-card
        class="d-flex justify-center align-center confirmEmailStepBackground"
        width="100%"
        height="100%"
        tile
        flat
      >
        <v-img
          v-if="!forgotPasswordCard && !changePasswordCard"
          class="imgCardFirstAccess"
          src="@/assets/email-code-validation.svg"
        >
        </v-img>
        <v-img
          v-else
          class="imgCardFirstAccess"
          src="@/assets/password-create.svg"
        ></v-img>
      </v-card>
    </v-col>
    <v-col
      v-if="!firstAccess"
      cols="12"
      md="12"
      sm="12"
      :class="$vuetify.breakpoint.smAndUp && 'fill-height'"
      class="d-flex flex-column align-center justify-space-between newBackground"
    >
      <v-row no-gutters justify="center" align="start">
        <v-col cols="12" class="my-6">
          <v-row align="center" justify="center">
            <v-col class="col-auto">
              <img
                v-if="$vuetify.theme.dark"
                :height="$vuetify.breakpoint.smAndUp ? '54' : '40'"
                class="mousePointer"
                src="../../assets/logoWhite.svg"
              />
              <img
                v-else
                :height="$vuetify.breakpoint.smAndUp ? '54' : '40'"
                class="mousePointer"
                src="../../assets/logoBlack.svg"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-card
          width="420px"
          class="loginCard"
          :class="$vuetify.breakpoint.smAndUp ? 'pa-12' : 'pa-6'"
          flat
        >
          <v-row
            v-if="changePasswordCard"
            no-gutters
            align="center"
            justify="center"
          >
            <v-col cols="12">
              <span
                class="welcomeText"
                :class="!$vuetify.theme.dark && 'lightModeColor'"
                >{{ $t('message.pages.login.setUpANewPass') }}</span
              >
            </v-col>
            <v-col cols="12">
              <span>{{ $t('message.pages.login.chooseNewPassword') }}</span>
            </v-col>
            <v-col cols="12" class="mt-4">
              <span class="attributesText" style="letter-spacing: 0cm">
                {{ $t('message.sentRecoverCode') }}
                {{ forgetPasswordData.email }}
              </span>
              <v-input
                v-model="forgetPasswordData.code"
                dense
                autofocus
                single-line
                outlined
                tabindex="2"
                hide-details
                style="max-width: 260px"
              ></v-input>
            </v-col>
            <v-col cols="12" class="mt-4">
              <span class="attributesText">{{
                $t('message.newPassword')
              }}</span>
              <v-input
                v-model="changePass.password"
                class="attributesText mb-2"
                autocomplete="false"
                :placeholder="$t('message.pages.login.insertPassPlaceholder')"
                outlined
                hide-details
                dense
                :append-icon="showChangePass ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showChangePass ? 'text' : 'password'"
                @click:append="showChangePass = !showChangePass"
                tabindex="2"
                style="max-width: 260px"
              ></v-input>
            </v-col>
            <v-col cols="12" class="pt-0 pb-2">
              <v-card flat width="100%" height="155">
                <v-row no-gutters>
                  <v-col cols="12" class="pl-1 pb-3">
                    <span class="mustHaveText">{{
                      $t('message.pages.login.itMustHave')
                    }}</span>
                  </v-col>
                  <v-col cols="12" class="pl-1 pb-3 pt-5 requirementsText">
                    <v-row no-gutters>
                      <v-icon
                        :color="checkPasswordHasNumber ? 'green' : 'grey'"
                        size="14"
                      >
                        mdi-check-circle
                      </v-icon>
                      <span class="ml-2"
                        >{{ $t('message.pages.login.numbers') }}
                      </span>
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="pl-1 requirementsText">
                    <v-row no-gutters>
                      <v-icon
                        :color="checkMinimunCharacters ? 'green' : 'grey'"
                        size="14"
                      >
                        mdi-check-circle
                      </v-icon>
                      <span class="ml-2">{{
                        $t('message.pages.login.minCharacters')
                      }}</span>
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="pl-1 py-3 requirementsText">
                    <v-row no-gutters>
                      <v-icon
                        :color="checkSpecialCharacters ? 'green' : 'grey'"
                        size="14"
                      >
                        mdi-check-circle
                      </v-icon>
                      <span class="ml-2">{{
                        $t('message.pages.login.specialCharacters')
                      }}</span>
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="pl-1 requirementsText">
                    <v-row no-gutters>
                      <v-icon
                        :color="checkLetters ? 'green' : 'grey'"
                        size="14"
                      >
                        mdi-check-circle
                      </v-icon>
                      <span class="ml-2">{{
                        $t('message.pages.login.differentLetters')
                      }}</span>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="12" class="mt-6">
              <span class="attributesText"
                >{{ $t('message.repeatPassword') }}
              </span>
              <v-text-field
                v-model="changePass.repeatPassword"
                class="attributesText"
                autocomplete="false"
                outlined
                dense
                :placeholder="$t('message.pages.login.confirmPassPlaceholder')"
                :messages="changeConfirmPasswordErrorMessage"
                :error="
                  changePasswordError.passwordsNotEqual ||
                  changePasswordError.minError ||
                  changePasswordError.notSafeError ||
                  changePasswordError.invalidPassword ||
                  changePasswordError.limitExceeded ||
                  changePasswordError.expiredCode ||
                  newPasswordError.notSafeError ||
                  newPasswordError.codeMismatchException ||
                  newPasswordError.newPasswordError ||
                  newPasswordError.unexpectedError ||
                  newPasswordError.passwordsNotEqual
                "
                :append-icon="showChangePassRepeat ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showChangePassRepeat ? 'text' : 'password'"
                @click:append="showChangePassRepeat = !showChangePassRepeat"
                tabindex="2"
                @blur="checkIfBothPasswordAreEqual"
                @input="onChangeRepeatPasswordInput"
                @keydown.enter="handleEnterOnPass"
                style="max-width: 260px"
              >
                <template v-slot:message="{ message }">
                  <span
                    class="red--text caption align-text"
                    v-if="
                      changePasswordError.minError ||
                      changePasswordError.notSafeError ||
                      changePasswordError.invalidPassword ||
                      changePasswordError.limitExceeded ||
                      changePasswordError.expiredCode ||
                      newPasswordError.minError ||
                      newPasswordError.notSafeError ||
                      newPasswordError.invalidPassword ||
                      newPasswordError.limitExceeded ||
                      newPasswordError.codeMismatchException ||
                      newPasswordError.newPasswordError ||
                      newPasswordError.unexpectedError ||
                      newPasswordError.passwordsNotEqual
                    "
                  >
                    <v-icon color="red" size="18" class="pb-1">
                      mdi-alert-circle</v-icon
                    >
                    {{ message }}
                  </span>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12">
              <v-checkbox
                :disabled="signInLoading"
                v-model="forgetSessions"
                :label="$t('message.pages.login.logoutSessions')"
                class="ma-0"
              >
              </v-checkbox>
            </v-col>
            <v-col cols="12">
              <v-btn
                large
                color="primary"
                :loading="changePasswordLoading"
                :disabled="changePasswordLoading"
                @click="handleForgetPasswordChangePass"
              >
                {{ $t('message.pages.login.changeMyPass') }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row
            v-else-if="forgotPasswordCard"
            no-gutters
            align="center"
            justify="center"
          >
            <v-col cols="12">
              <span
                class="welcomeText"
                :class="!$vuetify.theme.dark && 'lightModeColor'"
              >
                <v-btn icon text class="mb-1" @click="cancelForgetPassword">
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
                {{ $t('message.pages.login.updatePassword') }}
              </span>
            </v-col>
            <span>
              {{ $t('message.pages.login.dontWorryEmail') }}
              {{ $t('message.pages.login.weWillSend') }}
            </span>
            <v-col cols="12" class="mt-10">
              <span class="attributesText">
                {{ $t('message.pages.login.email') }}
              </span>
              <v-text-field
                v-model="forgetPasswordData.email"
                dense
                prepend-inner-icon="mdi-email-outline"
                type="text"
                autocomplete="off"
                outlined
                :messages="forgetPasswordErrorMessage"
                :error="
                  forgetPasswordError.invalidAccount ||
                  forgetPasswordError.emptyFields ||
                  forgetPasswordError.currentState ||
                  forgetPasswordError.limitExceeded ||
                  forgetPasswordError.unexpectedError
                "
                @keyup.enter="handleSendForgetPasswordCode"
              >
                <template v-slot:message="{ message }">
                  <span
                    class="red--text caption align-text"
                    v-if="forgetPasswordError"
                  >
                    <v-icon color="red" size="18" class="pb-1">
                      mdi-alert-circle
                    </v-icon>
                    {{ message }}
                  </span>
                  <button
                    v-if="
                      forgetPasswordError.currentState &&
                      !forgetLoading1 &&
                      !resentCode &&
                      !resentLoading
                    "
                    type="button"
                    class="primary--text footerText textButton"
                    @click="
                      handleResendPassword(
                        forgetPasswordData.email,
                        'recover-pass'
                      )
                    "
                  >
                    {{ $t('message.resendTemporaryPassword') }}
                  </button>
                  <span
                    v-if="resentLoading"
                    class="primary--text footerText textButton"
                  >
                    <br />
                    <p class="pl-5">
                      {{
                        $t('message.pages.login.sendingTo', {
                          email: forgetPasswordData.email,
                        })
                      }}
                      <v-progress-circular
                        indeterminate
                        size="14"
                        width="2"
                        color="primary"
                      ></v-progress-circular>
                    </p>
                  </span>
                  <span
                    v-if="resentCode && !resentLoading"
                    class="black--text footerText textButton"
                  >
                    <br />
                    <p
                      class="pl-5"
                      v-html="
                        $t('message.pages.login.tempPassSentTo', {
                          email: forgetPasswordData.email,
                        })
                      "
                    ></p>
                  </span>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" :class="$vuetify.breakpoint.mdAndUp && 'mt-1'">
              <v-spacer />
              <v-btn
                large
                block
                color="primary"
                :loading="forgetLoading1"
                :disabled="forgetLoading1 || emailSent"
                @click="handleSendForgetPasswordCode"
              >
                <span class="mx-12" v-if="!emailSent">
                  {{ $t('message.pages.login.sendLink') }}
                </span>
                <span class="mx-12" v-else>
                  {{ $t('message.pages.login.linkSent') }}
                  <v-icon>mdi-check-all</v-icon>
                </span>
              </v-btn>
            </v-col>
          </v-row>
          <!-- login page -->
          <v-row v-else no-gutters align="center" justify="center">
            <span
              class="welcomeText"
              :class="{
                lightModeColor: !$vuetify.theme.dark,
                'mb-10': $vuetify.breakpoint.smAndUp,
                'mb-4': !$vuetify.breakpoint.smAndUp,
              }"
            >
              {{ $t('message.pages.login.beWelcomeAgain') }}
            </span>
            <v-col cols="12">
              <span class="attributesText">{{
                $t('message.pages.login.email')
              }}</span>
              <v-text-field
                v-model="login.user.email"
                dense
                class="mb-6"
                prepend-inner-icon="mdi-email-outline"
                type="text"
                outlined
                @keyup.enter="handleLogin"
                hide-details
              >
              </v-text-field>
            </v-col>
            <v-col cols="12">
              <span class="attributesText mr-2">{{
                $t('message.password')
              }}</span>
              <v-text-field
                v-model="login.user.password"
                dense
                prepend-inner-icon="mdi-lock-outline"
                hide-details
                :append-icon="showLoginPass ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showLoginPass ? 'text' : 'password'"
                @click:append="showLoginPass = !showLoginPass"
                outlined
                :messages="loginPasswordErrorMessage"
                @keyup.enter="handleLogin"
                :error="
                  login.error.invalidAccountError ||
                  login.error.userNotFound ||
                  login.error.unexpectedError ||
                  login.error.resetPasswordRequired ||
                  forgetPasswordError.invalidAccount ||
                  forgetPasswordError.currentState ||
                  forgetPasswordError.limitExceeded ||
                  forgetPasswordError.unexpectedError
                "
              >
                <template v-slot:message="{ message }">
                  <span
                    class="red--text caption align-text"
                    v-if="
                      login.error.invalidAccountError ||
                      login.error.userNotFound ||
                      login.error.emptyFields ||
                      login.error.unexpectedError ||
                      login.error.resetPasswordRequired ||
                      forgetPasswordError.invalidAccount ||
                      forgetPasswordError.currentState ||
                      forgetPasswordError.limitExceeded ||
                      forgetPasswordError.unexpectedError
                    "
                  >
                    <v-icon color="red" size="18" class="pb-1">
                      mdi-alert-circle
                    </v-icon>
                    {{ message }}
                  </span>
                </template>
              </v-text-field>
              <v-row no-gutters class="mt-1">
                <button
                  type="button"
                  class="primary--text footerText textButton"
                  @click="handleForgetPassword"
                >
                  {{ $t('message.forgotPassword') }}
                </button>
              </v-row>
            </v-col>
            <v-col cols="12" class="mt-7">
              <v-btn
                large
                block
                class="primary white--text"
                :loading="signInLoading"
                :disabled="signInLoading"
                @click="handleLogin"
              >
                <span>{{ $t('message.signIn') }}</span>
              </v-btn>
            </v-col>
            <v-col cols="12" class="mt-13">
              <v-row no-gutters align="center" justify="center">
                <span class="helpLinks">
                  {{ $t('message.noAccount') }}
                  <a @click="signupPage()">{{ $t('message.createHere') }}</a>
                </span>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-row>
      <v-row
        v-if="$vuetify.breakpoint.mdAndUp"
        no-gutters
        align="end"
        class="pb-9"
        justify="center"
        style="width: 100%"
      >
        <v-col cols="4"></v-col>
        <v-col cols="4" class="d-flex flex-row align-center justify-center">
          <span class="mr-4">
            <a :href="helpLink" target="_blank" class="helpLinks">
              {{ $t('message.help') }}
            </a>
          </span>
          <span class="pl-8">
            <a
              href="https://pandavideo.com.br/privacy/"
              target="_blank"
              class="helpLinks"
            >
              {{ $t('message.privacyPolicy') }}
            </a>
          </span>
        </v-col>
        <v-col cols="4" class="pr-6">
          <v-row no-gutters justify="end">
            <span class="helpLinks"> &copy; {{ getYear }} Panda Video </span>
          </v-row>
        </v-col>
      </v-row>
      <v-row
        v-else
        no-gutters
        align="end"
        class="pb-9 pt-4"
        justify="center"
        style="width: 100%"
      >
        <v-col
          cols="7"
          class="pl-4 d-flex flex-row align-center justify-center"
        >
          <span class="mr-4">
            <a :href="helpLink" target="_blank" class="helpLinks">
              {{ $t('message.help') }}
            </a>
          </span>
          <span class="pl-4">
            <a
              href="https://pandavideo.com.br/privacy/"
              target="_blank"
              class="helpLinks"
            >
              {{ $t('message.privacyPolicy') }}
            </a>
          </span>
        </v-col>
        <v-col cols="5" class="pr-6">
          <v-row no-gutters justify="end">
            <span class="helpLinks"> &copy; {{ getYear }} Panda Video </span>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
    <v-col
      v-else
      cols="12"
      :md="creatingAccount ? '12' : '6'"
      sm="12"
      class="fill-height"
    >
      <v-card
        v-if="creatingAccount"
        width="100%"
        height="100%"
        flat
        tile
        class="d-flex flex-column align-center justify-center confirmEmailStepBackground"
      >
        <v-row>
          <v-col class="d-flex flex-column align-center justify-center">
            <div
              class="d-flex flex-row align-center justify-center flex-column"
            >
              <img
                src="../../assets/logo-symbol-pandavideo.svg"
                class="welcomePandaIcon"
              />
              <span class="prepAccount text-center mt-5">
                {{ $t('message.pages.login.welcomeToPanda') }}
              </span>
              <div v-if="this.login.user.email === this.subscriptionEmail">
                <span class="subText mt-2">
                  {{ $t('message.pages.login.beforeStart') }}
                </span>
              </div>
              <base-btn
                type="neutral"
                class="startBtn mt-6"
                @click="goToQuestionary"
              >
                {{
                  $t('message.pages.AbTest.emptyState.actionButton')
                }}</base-btn
              >
            </div>
          </v-col>
        </v-row>
        <v-row
          v-if="warningCard && isBeta"
          no-gutters
          align="start"
          justify="center"
          class="pt-12"
        >
          <v-card
            max-width="600px"
            width="100%"
            color="feedback"
            class="mx-8"
            flat
          >
            <v-row
              no-gutters
              align="center"
              justify="center"
              class="flex-column"
            >
              <span class="mt-8 warningTitle">
                {{ $t('message.pages.login.warningTitle') }}
              </span>
              <span class="mt-2 warningSubtitle">
                {{ $t('message.pages.login.warningSubtitle') }}
              </span>
              <template v-if="!wasMessageSent">
                <span class="mt-6 mb-2 warningWhatsapp">
                  {{ $t('message.pages.login.warningWhatsapp') }}
                </span>
                <VuePhoneNumberInput
                  default-country-code="BR"
                  no-example
                  :preferred-countries="['BR', 'US']"
                  @update="handleUpdatePhone"
                  v-model="inputPhone"
                />
                <v-btn
                  class="mt-3"
                  color="primary"
                  :loading="sendWarningLoading"
                  :disabled="sendWarningLoading"
                  @click="handleWarnUser('number')"
                >
                  {{ $t('message.send') }}
                </v-btn>
              </template>
              <template v-else>
                <span class="mt-8 emailSentText">
                  {{ $t('message.pages.login.warningMessage') }}
                  <span v-if="sendType === 'email'">
                    email <b>{{ login.user.email }}</b>
                  </span>
                  <span v-else> Whatsapp {{ userPhone }}</span>
                </span>
              </template>
              <span
                v-if="wasMessageSent"
                class="my-8 warningEmail mousePointer"
                @click="handleHelp"
              >
                {{ $t('message.pages.login.warningNeedHelp') }}
              </span>
              <span
                v-else
                class="my-8 warningEmail mousePointer"
                @click="handleWarnUser('email')"
              >
                {{ $t('message.pages.login.warningEmail') }}
              </span>
            </v-row>
          </v-card>
        </v-row>
      </v-card>
      <v-card
        v-else-if="!forgotPasswordCard && !changePasswordCard"
        width="100%"
        height="100%"
        flat
        tile
        class="d-flex flex-column confirmEmailCard"
      >
        <v-card-title
          :class="$vuetify.breakpoint.mdAndUp ? 'mt-4' : ''"
          class="pb-0"
        >
          <v-row no-gutters class="d-flex flex-column align-center">
            <v-col
              :cols="$vuetify.breakpoint.mdAndUp ? '10' : '12'"
              :class="$vuetify.breakpoint.mdAndUp ? 'mt-3' : ''"
              class="d-flex flex-column"
            >
              <template v-if="firstAccess">
                <v-row class="mt-3 mb-6">
                  <v-col>
                    <img
                      v-if="$vuetify.theme.dark"
                      :height="$vuetify.breakpoint.smAndUp ? '54' : '40'"
                      class="mousePointer"
                      src="../../assets/logoWhite.svg"
                    />
                    <img
                      v-else
                      :height="$vuetify.breakpoint.smAndUp ? '54' : '40'"
                      class="mousePointer"
                      src="../../assets/logoBlack.svg"
                    />
                  </v-col>
                </v-row>
                <span class="welcomeTextFirstAccess"
                  >{{ $t('message.pages.login.confirmYourEmail') }}
                </span>
                <span class="subTextFirstAccess">
                  {{ $t('message.pages.login.confirmEmailText') }}
                </span>
                <span class="attributesTextFirstAccess mb-8">
                  {{ login.user.email }}
                </span>
              </template>
              <!-- title login page -->
              <template v-else>
                <span
                  class="welcomeText mb-10"
                  :class="!$vuetify.theme.dark && 'lightModeColor'"
                  >{{ $t('message.pages.login.beWelcomeAgain') }}</span
                >
              </template>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-row no-gutters class="justify-center align-center">
            <v-col :cols="$vuetify.breakpoint.mdAndUp ? '10' : '12'">
              <template v-if="!firstAccess">
                <span class="attributesText">{{
                  $t('message.pages.login.email')
                }}</span>
                <v-text-field
                  v-model="login.user.email"
                  class="mt-2"
                  prepend-inner-icon="mdi-email-outline"
                  type="text"
                  :placeholder="$t('message.pages.login.insertEmail')"
                  outlined
                  @keyup.enter="handleLogin"
                >
                </v-text-field>
                <span class="attributesText mr-2">{{
                  $t('message.password')
                }}</span>
              </template>
              <!-- confirm email flow -->
              <v-row>
                <v-col
                  :cols="$vuetify.breakpoint.mdAndUp ? '6' : '12'"
                  class="pb-0"
                >
                  <v-input
                    v-model="login.user.password"
                    class="mt-2 mb-2"
                    :label="$t('message.pages.login.confirmCodeEmail')"
                    :placeholder="$t('message.pages.login.insertCode')"
                    :append-icon="
                      showLoginPass ? 'mdi-eye-outline' : 'mdi-eye-off-outline'
                    "
                    :type="showLoginPass ? 'text' : 'password'"
                    @click:append="showLoginPass = !showLoginPass"
                    :messages="loginPasswordErrorMessage"
                    @keyup.enter="handleLogin"
                    :error="
                      login.error.emptyFields ||
                      login.error.invalidCodeError ||
                      login.error.invalidAccountError ||
                      login.error.userNotFound ||
                      login.error.unexpectedError ||
                      login.error.resetPasswordRequired ||
                      forgetPasswordError.invalidAccount ||
                      forgetPasswordError.currentState ||
                      forgetPasswordError.limitExceeded ||
                      forgetPasswordError.unexpectedError
                    "
                  >
                    <template v-slot:message="{ message }">
                      <span
                        class="red--text caption align-text"
                        v-if="
                          login.error.invalidAccountError ||
                          login.error.userNotFound ||
                          login.error.emptyFields ||
                          login.error.unexpectedError ||
                          login.error.resetPasswordRequired ||
                          forgetPasswordError.invalidAccount ||
                          forgetPasswordError.currentState ||
                          forgetPasswordError.limitExceeded ||
                          forgetPasswordError.unexpectedError
                        "
                      >
                        <v-icon color="red" size="18" class="pb-1">
                          mdi-alert-circle
                        </v-icon>
                        {{ message }}
                      </span>
                    </template>
                  </v-input>
                </v-col>
              </v-row>

              <!-- resend Code confirm Email flow -->
              <template>
                <span>{{ $t('message.pages.login.notReceived') }} </span>
                <a
                  type="primary"
                  @click="
                    handleResendPassword(login.user.email, 'first-access')
                  "
                >
                  {{ $t('message.pages.login.sendAgain') }}
                </a>
              </template>
              <v-row v-if="!firstAccess" no-gutters justify="end" align="end">
                <button
                  type="button"
                  class="primary--text footerText textButton"
                  @click="handleForgetPassword"
                >
                  <u>{{ $t('message.forgotPassword') }}</u>
                </button>
              </v-row>
            </v-col>
            <v-col :cols="$vuetify.breakpoint.mdAndUp ? '10' : '12'">
              <base-btn
                class="white--text"
                :class="$vuetify.breakpoint.mdAndUp ? 'mt-6 w-full' : ''"
                :loading="signInLoading"
                :disabled="signInLoading"
                type="primary"
                @click="handleLogin"
              >
                <span>{{ $t('message.actions.confirm') }}</span>
              </base-btn>
            </v-col>
            <v-col
              v-if="!firstAccess"
              :cols="$vuetify.breakpoint.mdAndUp ? '10' : '12'"
              class="mt-4"
            >
              <span class="footerText">
                {{ $t('message.noAccount') }}
                <a @click="signupPage()">{{ $t('message.createHere') }}</a>
              </span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-row no-gutters class="mb-3 justify-md-center align-end">
          <v-col :cols="$vuetify.breakpoint.mdAndUp ? '10' : '12'">
            <v-row no-gutters class="mb-3 mb-md-12">
              <v-col
                :cols="$vuetify.breakpoint.mdAndUp ? '6' : '12'"
                class="d-flex flex-column flex-md-row pl-3 pl-0 align-center ga-4"
              >
                <span class="mr-4 d-inline-flex">
                  <a
                    :href="helpLink"
                    target="_blank"
                    type="secondary"
                    size="xsmall"
                  >
                    {{ $t('message.help') }}
                  </a>
                </span>
                <span class="d-inline-flex mt-4 mt-md-0">
                  <a
                    href="https://pandavideo.com.br/privacy/"
                    target="_blank"
                    type="secondary"
                    size="xsmall"
                  >
                    {{ $t('message.privacyPolicy') }}
                  </a>
                </span>
              </v-col>
              <v-spacer />
              <v-col
                :cols="$vuetify.breakpoint.mdAndUp ? '4' : '12'"
                align-self="end"
              >
                <v-row
                  no-gutters
                  align="start"
                  class="justify-center justify-md-end mt-4 mt-md-0 flex-column-reverse flex-md-row align-center"
                >
                  <img
                    src="@/assets/logo-symbol-pandavideo.svg"
                    class="iconFooter mt-4 mt-md-0 mr-0 mr-md-2"
                  />
                  <span class="helpLinks d-inline-flex">
                    &copy; {{ getYear }} Panda Video
                  </span>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
      <!-- Forgot Password -->
      <v-card
        v-if="forgotPasswordCard && forgetPasswordStep === 1"
        width="100%"
        height="100%"
        flat
        tile
        class="d-flex flex-column"
      >
        <v-card-title class="mt-4">
          <v-row
            no-gutters
            class="d-flex flex-column align-center justify-center"
          >
            <v-col cols="10" class="mt-3">
              <span
                class="welcomeText"
                :class="!$vuetify.breakpoint.smAndUp && 'lightModeColor'"
                >{{ $t('message.forgotPassword') }}</span
              >
            </v-col>
            <v-col cols="10">
              <span class="subtitleText wrapText"
                >{{ $t('message.pages.login.dontWorryEmail') }}
                {{ $t('message.pages.login.weWillSend') }}
              </span>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="mb-0 pb-0">
          <v-row no-gutters class="justify-center align-center">
            <v-col cols="10" class="mt-4">
              <span class="attributesText">{{
                $t('message.pages.login.email')
              }}</span>
              <v-text-field
                v-model="forgetPasswordData.email"
                class="mt-2"
                prepend-inner-icon="mdi-email-outline"
                type="text"
                :placeholder="$t('message.pages.login.insertEmail')"
                autocomplete="off"
                outlined
                :messages="forgetPasswordErrorMessage"
                :error="
                  forgetPasswordError.invalidAccount ||
                  forgetPasswordError.emptyFields ||
                  forgetPasswordError.currentState ||
                  forgetPasswordError.limitExceeded ||
                  forgetPasswordError.unexpectedError
                "
                @keyup.enter="handleSendForgetPasswordCode"
              >
                <template v-slot:message="{ message }">
                  <span
                    class="red--text caption align-text"
                    v-if="forgetPasswordError"
                  >
                    <v-icon color="red" size="18" class="pb-1">
                      mdi-alert-circle
                    </v-icon>
                    {{ message }}
                  </span>
                  <button
                    v-if="
                      forgetPasswordError.currentState &&
                      !forgetLoading1 &&
                      !resentCode &&
                      !resentLoading
                    "
                    type="button"
                    class="primary--text footerText textButton"
                    @click="
                      handleResendPassword(
                        forgetPasswordData.email,
                        'recover-pass'
                      )
                    "
                  >
                    {{ $t('message.resendTemporaryPassword') }}
                  </button>
                  <span
                    v-if="resentLoading"
                    class="primary--text footerText textButton"
                  >
                    <br />
                    <p class="pl-5">
                      {{
                        $t('message.pages.login.sendingTo', {
                          email: forgetPasswordData.email,
                        })
                      }}
                      <v-progress-circular
                        indeterminate
                        size="14"
                        width="2"
                        color="primary"
                      ></v-progress-circular>
                    </p>
                  </span>
                  <span
                    v-if="resentCode && !resentLoading"
                    class="black--text footerText textButton"
                  >
                    <br />
                    <p
                      class="pl-5"
                      v-html="
                        $t('message.pages.login.tempPassSentTo', {
                          email: forgetPasswordData.email,
                        })
                      "
                    ></p>
                  </span>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="10" :class="$vuetify.breakpoint.mdAndUp && 'mt-8'">
              <v-spacer />
              <v-btn
                large
                block
                color="primary"
                :loading="forgetLoading1"
                :disabled="forgetLoading1 || emailSent"
                @click="handleSendForgetPasswordCode"
              >
                <span class="mx-12" v-if="!emailSent">{{
                  $t('message.pages.login.sendLink')
                }}</span>
                <span class="mx-12" v-else>
                  {{ $t('message.pages.login.linkSent') }}
                  <v-icon>mdi-check-all</v-icon>
                </span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-row no-gutters align="center" justify="center">
          <v-col cols="10">
            <v-row no-gutters justify="space-between">
              <v-col cols="5" class="pt-3">
                <v-divider />
              </v-col>
              <v-col cols="2" md="1" sm="2">
                <span class="d-flex justify-center orText">{{
                  $t('message.pages.login.or')
                }}</span>
              </v-col>
              <v-col cols="5" class="pt-3">
                <v-divider />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="10" :class="$vuetify.breakpoint.smAndDown && 'mt-6'">
            <v-btn
              color="#D6D6D6"
              outlined
              large
              block
              @click="cancelForgetPassword"
            >
              <v-icon>mdi-login-variant</v-icon>
              <span class="pl-4">{{
                $t('message.pages.login.loginPage')
              }}</span>
            </v-btn>
          </v-col>
        </v-row>
        <v-row no-gutters class="mb-3 justify-md-center align-end">
          <v-col :cols="$vuetify.breakpoint.mdAndUp ? '10' : '12'">
            <v-row no-gutters class="mb-3 mb-md-12">
              <v-col
                :cols="$vuetify.breakpoint.mdAndUp ? '6' : '12'"
                class="d-flex flex-column flex-md-row pl-3 pl-0 align-center ga-4"
              >
                <span class="mr-4 d-inline-flex">
                  <a
                    :href="helpLink"
                    target="_blank"
                    type="secondary"
                    size="xsmall"
                  >
                    {{ $t('message.help') }}
                  </a>
                </span>
                <span class="d-inline-flex mt-4 mt-md-0">
                  <a
                    href="https://pandavideo.com.br/privacy/"
                    target="_blank"
                    type="secondary"
                    size="xsmall"
                  >
                    {{ $t('message.privacyPolicy') }}
                  </a>
                </span>
              </v-col>
              <v-spacer />
              <v-col
                :cols="$vuetify.breakpoint.mdAndUp ? '4' : '12'"
                align-self="end"
              >
                <v-row
                  no-gutters
                  align="start"
                  class="justify-center justify-md-end mt-4 mt-md-0 flex-column-reverse flex-md-row align-center"
                >
                  <img
                    src="@/assets/logo-symbol-pandavideo.svg"
                    class="iconFooter mt-4 mt-md-0 mr-0 mr-md-2"
                  />
                  <span class="helpLinks d-inline-flex">
                    &copy; {{ getYear }} Panda Video
                  </span>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
      <!-- create password -->
      <v-card
        v-if="
          (changePasswordCard ||
            (forgotPasswordCard && forgetPasswordStep === 3)) &&
          !creatingAccount
        "
        width="100%"
        flat
        tile
        class="d-flex flex-column createPassword"
        height="100%"
      >
        <v-card-title
          :class="$vuetify.breakpoint.mdAndUp ? 'mt-0' : 'pb-2'"
          class="d-flex flex-column"
        >
          <v-col cols="12" class="pa-0 mb-2 mb-md-8">
            <v-row
              class="mt-3 mb-6 mb-md-8 mt-md-8 justify-center align-center"
            >
              <v-col
                :cols="$vuetify.breakpoint.mdAndUp ? '10' : '12'"
                class="d-flex flex-column align-start"
              >
                <img
                  v-if="$vuetify.theme.dark"
                  :height="$vuetify.breakpoint.smAndUp ? '54' : '40'"
                  class="mousePointer"
                  src="../../assets/logoWhite.svg"
                />
                <img
                  v-else
                  :height="$vuetify.breakpoint.smAndUp ? '54' : '40'"
                  class="mousePointer"
                  src="../../assets/logoBlack.svg"
                />
              </v-col>
            </v-row>
            <v-row no-gutters class="d-flex align-center justify-center">
              <v-col
                class="d-flex flex-column"
                :cols="$vuetify.breakpoint.mdAndUp ? '10' : '12'"
              >
                <span class="welcomeTextFirstAccess">
                  {{
                    firstAccess
                      ? $t('message.setPassword')
                      : $t('message.pages.login.defineNewPass')
                  }}
                </span>
                <span class="subTextFirstAccess">
                  {{ $t('message.pages.login.fillBlankFields') }}
                </span>
              </v-col>
            </v-row>
          </v-col>
        </v-card-title>
        <v-card-text class="mt-3">
          <v-row class="justify-center align-center">
            <v-col :cols="$vuetify.breakpoint.mdAndUp ? '10' : '12'">
              <v-row no-gutters class="justify-start align-center">
                <v-col :cols="$vuetify.breakpoint.mdAndUp ? '8' : '12'">
                  <v-input
                    v-model="changePass.password"
                    class="attributesText"
                    autocomplete="false"
                    outlined
                    :placeholder="
                      $t('message.pages.login.insertPassPlaceholder')
                    "
                    :label="$t('message.newPassword')"
                    :messages="changePasswordErrorMessage"
                    :error="
                      changePasswordError.minError ||
                      changePasswordError.notSafeError ||
                      changePasswordError.invalidPassword ||
                      changePasswordError.limitExceeded ||
                      changePasswordError.expiredCode ||
                      newPasswordError.minError ||
                      newPasswordError.notSafeError ||
                      newPasswordError.invalidPassword ||
                      newPasswordError.limitExceeded ||
                      newPasswordError.codeMismatchException ||
                      newPasswordError.newPasswordError ||
                      newPasswordError.unexpectedError
                    "
                    :append-icon="
                      showChangePass ? 'mdi-eye-outline' : 'mdi-eye-off-outline'
                    "
                    :type="showChangePass ? 'text' : 'password'"
                    @click:append="showChangePass = !showChangePass"
                    tabindex="2"
                    @blur="isSafePassword"
                  >
                  </v-input>
                </v-col>
                <v-col
                  :cols="$vuetify.breakpoint.mdAndUp ? '8' : '12'"
                  class="pt-0 mb-4"
                >
                  <v-card
                    flat
                    width="100%"
                    height="100%"
                    class="cardPasswordMustHave pa-4"
                  >
                    <v-row no-gutters class="flex-column">
                      <v-col cols="12" class="pl-1">
                        <span class="mustHaveText d-flex pb-1">{{
                          $t('message.pages.login.itMustHave')
                        }}</span>
                      </v-col>
                      <v-col cols="12" class="pl-1 pb-3 requirementsText">
                        <v-row no-gutters>
                          <v-icon
                            :color="checkPasswordHasNumber ? 'green' : 'grey'"
                            size="14"
                          >
                            mdi-check-circle
                          </v-icon>
                          <span class="ml-2"
                            >{{ $t('message.pages.login.numbers') }}
                          </span>
                        </v-row>
                      </v-col>
                      <v-col cols="12" class="pl-1 requirementsText">
                        <v-row no-gutters>
                          <v-icon
                            :color="checkMinimunCharacters ? 'green' : 'grey'"
                            size="14"
                          >
                            mdi-check-circle
                          </v-icon>
                          <span class="ml-2">{{
                            $t('message.pages.login.minCharacters')
                          }}</span>
                        </v-row>
                      </v-col>
                      <v-col cols="12" class="pl-1 py-3 requirementsText">
                        <v-row no-gutters>
                          <v-icon
                            :color="checkSpecialCharacters ? 'green' : 'grey'"
                            size="14"
                          >
                            mdi-check-circle
                          </v-icon>
                          <span class="ml-2">{{
                            $t('message.pages.login.specialCharacters')
                          }}</span>
                        </v-row>
                      </v-col>
                      <v-col cols="12" class="pl-1 requirementsText">
                        <v-row no-gutters>
                          <v-icon
                            :color="checkLetters ? 'green' : 'grey'"
                            size="14"
                          >
                            mdi-check-circle
                          </v-icon>
                          <span class="ml-2">{{
                            $t('message.pages.login.differentLetters')
                          }}</span>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
                <v-col
                  :cols="$vuetify.breakpoint.mdAndUp ? '8' : '12'"
                  class="mt-6"
                >
                  <template v-if="!firstAccess">
                    <span class="attributesText">
                      {{ $t('message.sentRecoverCode') }}
                      {{ forgetPasswordData.email }}
                    </span>
                    <v-text-field
                      v-model="forgetPasswordData.code"
                      autofocus
                      class="mt-2"
                      :label="$t('message.recoverCode')"
                      single-line
                      outlined
                      tabindex="2"
                    ></v-text-field>
                  </template>

                  <v-input
                    v-model="changePass.repeatPassword"
                    class="attributesText"
                    autocomplete="false"
                    outlined
                    :placeholder="
                      $t('message.pages.login.confirmPassPlaceholder')
                    "
                    :label="$t('message.repeatPassword')"
                    dense
                    :messages="changeConfirmPasswordErrorMessage"
                    :error="
                      changePasswordError.passwordsNotEqual ||
                      newPasswordError.passwordsNotEqual ||
                      newPasswordError.minError ||
                      newPasswordError.notSafeError ||
                      newPasswordError.invalidPassword ||
                      newPasswordError.limitExceeded ||
                      newPasswordError.codeMismatchException ||
                      newPasswordError.newPasswordError ||
                      newPasswordError.unexpectedError
                    "
                    :append-icon="
                      showChangePassRepeat
                        ? 'mdi-eye-outline'
                        : 'mdi-eye-off-outline'
                    "
                    :type="showChangePassRepeat ? 'text' : 'password'"
                    @click:append="showChangePassRepeat = !showChangePassRepeat"
                    tabindex="2"
                    @blur="checkIfBothPasswordAreEqual"
                    @keydown.enter="handleEnterOnPass"
                  >
                  </v-input>
                </v-col>
                <v-col
                  :cols="$vuetify.breakpoint.mdAndUp ? '10' : '12'"
                  :class="$vuetify.breakpoint.mdAndUp ? 'mt-0' : 'mt-4'"
                >
                  <base-btn
                    v-if="firstAccess"
                    large
                    type="primary"
                    class="text-none"
                    :loading="changePasswordLoading"
                    :disabled="changePasswordLoading"
                    @click="handleChangePass"
                  >
                    <span>{{ $t('message.confirmPass') }}</span>
                  </base-btn>
                  <base-btn
                    v-else
                    large
                    block
                    color="primary"
                    :loading="changePasswordLoading"
                    :disabled="!isSafePassword || changePasswordLoading"
                    @click="handleForgetPasswordChangePass"
                  >
                    <span>{{ $t('message.pages.login.changeMyPass') }}</span>
                  </base-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-row no-gutters class="mb-3 justify-md-center align-end">
          <v-col :cols="$vuetify.breakpoint.mdAndUp ? '10' : '12'">
            <v-row no-gutters class="mb-3 mb-md-12">
              <v-col
                :cols="$vuetify.breakpoint.mdAndUp ? '6' : '12'"
                class="d-flex flex-column flex-md-row pl-3 pl-0 align-center ga-4"
              >
                <span class="mr-4 d-inline-flex">
                  <a
                    :href="helpLink"
                    target="_blank"
                    type="secondary"
                    size="xsmall"
                  >
                    {{ $t('message.help') }}
                  </a>
                </span>
                <span class="d-inline-flex mt-4 mt-md-0">
                  <a
                    href="https://pandavideo.com.br/privacy/"
                    target="_blank"
                    type="secondary"
                    size="xsmall"
                  >
                    {{ $t('message.privacyPolicy') }}
                  </a>
                </span>
              </v-col>
              <v-spacer />
              <v-col
                :cols="$vuetify.breakpoint.mdAndUp ? '4' : '12'"
                align-self="end"
              >
                <v-row
                  no-gutters
                  align="start"
                  class="justify-center justify-md-end mt-4 mt-md-0 flex-column-reverse flex-md-row align-center"
                >
                  <img
                    src="@/assets/logo-symbol-pandavideo.svg"
                    class="iconFooter mt-4 mt-md-0 mr-0 mr-md-2"
                  />
                  <span class="helpLinks d-inline-flex">
                    &copy; {{ getYear }} Panda Video
                  </span>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
    <template>
      <TwoFactorLoginModal
        @success="handleLoginSuccess2FA"
        @close="signInLoading = false"
      />
    </template>
  </v-row>
</template>

<script>
import i18n from '@/translations/lang'
import { mapActions, mapMutations, mapState } from 'vuex'
import axios from 'axios'
import { API_URL } from '../../config/envs'
import { mask } from 'vue-the-mask'
import linkHelper from '@/utils/linkHelper.mixin.js'
import videosApi from '../../services/videosApi'
import planApi from '../../services/planApi'
import VuePhoneNumberInput from 'vue-phone-number-input'
import organizationApi from '@/services/organizationApi'
import facebookConversionApi from '../../services/facebookConversionApi'
import TwoFactorLoginModal from '@/components/2FA/TwoFactorLoginModal.vue'

export default {
  name: 'Login',
  directives: { mask },
  components: { VuePhoneNumberInput, TwoFactorLoginModal },
  mixins: [linkHelper],
  data: () => ({
    isBeta: false,
    forgetSessions: false,
    additional: [],
    model: 0,
    colors: ['primary', 'secondary', 'yellow darken-2'],
    signInLoading: false,
    login: {
      user: {
        email: '',
        name: '',
        password: '',
      },
      error: {
        invalidAccountError: false,
        invalidCodeError: false,
        userNotFound: false,
        emptyFields: false,
        unexpectedError: false,
        resetPasswordRequired: false,
      },
    },
    errors: {
      invalidCpf: false,
      invalidCnpj: false,
      cnpjCpfEmptyField: false,
      checkboxAcceptTerms: true,
    },
    // subscriptionEmail: false,
    resentCodeFirst: false,
    changePasswordCard: false,
    changePasswordLoading: false,
    showChangePass: false,
    showChangePassRepeat: false,
    showLoginPass: false,
    resentCode: false,
    resentLoading: false,
    changePasswordError: {
      minError: false,
      notSafeError: false,
      invalidPassword: false,
      limitExceeded: false,
      expiredCode: false,
    },
    changePass: {
      password: '',
      repeatPassword: '',
    },
    forgotPasswordCard: false,
    forgetLoading1: false,
    forgetPasswordStep: 1,
    emailSent: false,
    forgetPasswordData: {
      email: '',
      code: '',
      newPassword: '',
    },
    forgetPasswordError: {
      invalidAccount: false,
      emptyFields: false,
      currentState: false,
      limitExceeded: false,
      unexpectedError: false,
    },
    showNewPassword: false,
    newPasswordError: {
      minError: false,
      notSafeError: false,
      invalidPassword: false,
      limitExceeded: false,
      codeMismatchException: false,
      newPasswordError: false,
      unexpectedError: false,
      parameterException: false,
      passwordsNotEqual: false,
    },
    unknownError: '',
    firstAccess: false,
    checkboxPhysicalPerson: false,
    checkboxLegalPerson: true,
    checkboxAcceptTerms: false,
    tabs: null,
    singUpSteps: [
      {
        title: i18n.t('message.pages.login.signUp'),
        done: true,
        type: 'signup',
      },
      {
        title: i18n.t('message.pages.login.payment'),
        done: true,
        type: 'payment',
      },
      {
        title: i18n.t('message.pages.login.confirmEmail'),
        done: true,
        type: 'email',
      },
      {
        title: i18n.t('message.pages.login.setPass'),
        done: true,
        type: 'password',
      },
      {
        title: i18n.t('message.pages.login.conclusion'),
        done: true,
        type: 'complete',
      },
    ],
    creatingAccount: false,
    alreadyCreated: false,
    planAmount: 0,
    currency: 'brl',
    userPhone: '',
    sendType: 'number',
    wasMessageSent: false,
    inputPhone: '',
    sendWarningLoading: false,
    warningCard: false,
  }),
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
    helpLink() {
      return this.getHelpLink()
    },
    getYear() {
      const date = new Date()
      return date.getFullYear()
    },
    loginPasswordErrorMessage() {
      if (this.login.error.invalidAccountError) {
        let params = location.search
          .slice(1)
          .split('&')
          .map((p) => p.split('='))
          .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {})
        let accessType = params.type
        let errorMsg = ''
        accessType === 'first-access'
          ? (errorMsg = i18n.t('message.errors.invalidCodeError'))
          : (errorMsg = i18n.t('message.errors.invalidAccountError'))
        return errorMsg
      }
      if (this.login.error.userNotFound) {
        return i18n.t('message.errors.userNotFound')
      }
      if (this.login.error.emptyFields) {
        return i18n.t('message.errors.emptyFields')
      }
      if (this.login.error.resetPasswordRequired) {
        return i18n.t('message.errors.resetPasswordRequired')
      }
      if (this.login.error.unexpectedError) {
        return i18n.t('message.errors.unexpectedError')
      }
      if (this.forgetPasswordError.invalidAccount) {
        return i18n.t('message.errors.invalidAccount')
      }
      if (this.forgetPasswordError.emptyFields) {
        return i18n.t('message.errors.emptyFields')
      }
      if (this.forgetPasswordError.currentState) {
        return i18n.t('message.errors.currentState')
      }
      if (this.forgetPasswordError.limitExceeded) {
        return i18n.t('message.errors.limitExceeded')
      }
      if (this.forgetPasswordError.unexpectedError) {
        return i18n.t('message.errors.unexpectedError') + this.unknownError
      }
      return ''
    },
    changeConfirmPasswordErrorMessage() {
      if (this.newPasswordError.passwordsNotEqual) {
        return i18n.t('message.errors.notEqualPassword')
      }
      return ''
    },
    changePasswordErrorMessage() {
      if (this.changePasswordError.minError) {
        return i18n.t('message.errors.minError')
      }
      if (
        this.changePasswordError.notSafeError ||
        this.changePasswordError.invalidPassword
      ) {
        return i18n.t('message.errors.passwordNeeds')
      }
      if (this.changePasswordError.limitExceeded) {
        return i18n.t('message.errors.limitExceeded')
      }
      if (this.changePasswordError.expiredCode) {
        return 'Código expirado'
      }
      if (this.newPasswordError.minError) {
        return i18n.t('message.errors.minError')
      }
      if (
        this.newPasswordError.notSafeError ||
        this.newPasswordError.invalidPassword
      ) {
        return i18n.t('message.errors.passwordNeeds')
      }
      if (this.newPasswordError.limitExceeded) {
        return i18n.t('message.errors.limitExceeded')
      }
      if (this.newPasswordError.codeMismatchException) {
        return i18n.t('message.errors.codeMismatchException')
      }
      if (this.newPasswordError.parameterException) {
        return i18n.t('message.errors.parameterException')
      }
      if (this.newPasswordError.unexpectedError) {
        return i18n.t('message.errors.unexpectedError') + this.unknownError
      }
      return ''
    },
    forgetPasswordErrorMessage() {
      if (this.forgetPasswordError.invalidAccount) {
        return i18n.t('message.errors.invalidAccount')
      }
      if (this.forgetPasswordError.emptyFields) {
        return i18n.t('message.errors.emptyFields')
      }
      if (this.forgetPasswordError.currentState) {
        return i18n.t('message.errors.currentState')
      }
      if (this.forgetPasswordError.limitExceeded) {
        return i18n.t('message.errors.limitExceeded')
      }
      if (this.forgetPasswordError.unexpectedError) {
        return i18n.t('message.errors.unexpectedError') + this.unknownError
      }
      return ''
    },
    newPasswordErrorMessage() {
      if (this.newPasswordError.minError) {
        return i18n.t('message.errors.minError')
      }
      if (
        this.newPasswordError.notSafeError ||
        this.newPasswordError.invalidPassword
      ) {
        return i18n.t('message.errors.passwordNeeds')
      }
      if (this.newPasswordError.limitExceeded) {
        return i18n.t('message.errors.limitExceeded')
      }
      if (this.newPasswordError.codeMismatchException) {
        return i18n.t('message.errors.codeMismatchException')
      }
      if (this.newPasswordError.unexpectedError) {
        return i18n.t('message.errors.unexpectedError')
      }
      return ''
    },
    checkPasswordHasNumber() {
      const regex = new RegExp('^((?=.*[0-9]))')
      const regexTest = regex.test(this.changePass.password)
      return regexTest
    },
    checkMinimunCharacters() {
      const regex = new RegExp('^((?=.{8,}))')
      const regexTest = regex.test(this.changePass.password)
      return regexTest
    },
    checkSpecialCharacters() {
      const regex = new RegExp('^((?=.*[!@#$%^&*]))')
      const regexTest = regex.test(this.changePass.password)
      return regexTest
    },
    checkLetters() {
      const regex = new RegExp('^((?=.*[a-z])(?=.*[A-Z]))')
      const regexTest = regex.test(this.changePass.password)
      return regexTest
    },
    isDomainFromBrazil() {
      return location.host.match(/.com$/) ? false : true
    },
  },
  mounted() {
    this.$root.$on('callLogin', this.handleCallLogin)
  },
  async created() {
    this.isBeta = location.search.match('beta')
    this.$root.$emit('handleLoginRoute')
    let params = location.search
      .slice(1)
      .split('&')
      .map((p) => p.split('='))
      .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {})
    let accessType = params.type
    if (accessType === 'first-access' && params.email) {
      this.firstAccess = true
      this.login.user.email = params.email
      this.UPDATE_FIRST_ACCESS(true)
      const tempKey = sessionStorage.getItem('tempAccessKey')
      if (tempKey) {
        this.changePasswordCard = true
        this.login.user.password = tempKey
        this.handleLogin()
      }
    }
    if (accessType === 'recover-pass') {
      this.forgetPasswordData.email = params.email
      this.forgetPasswordData.code = params.code
      this.changePasswordCard = true
    }
    this.removeCrisp()
  },
  watch: {
    'changePass.repeatPassword': () => {
      if (
        this.changePass?.repeatPassword?.length > 0 &&
        this.changePass?.repeatPassword !== this.changePass?.password
      ) {
        this.changePasswordError.passwordsNotEqual = true
      } else {
        this.changePasswordError.passwordsNotEqual = false
      }
    },
  },
  methods: {
    handleLoginSuccess2FA() {
      window.location.reload()
    },
    ...mapActions('user', ['updateUser']),
    ...mapMutations('user', [
      'UPDATE_GLOBAL_SNACKBAR',
      'UPDATE_FIRST_ACCESS',
      'UPDATE_USER_ALLINFO',
    ]),
    ...mapActions('session', ['signInUser', 'fetchSession']),
    isSafePassword() {
      this.changePasswordError.notSafeError =
        !this.checkPasswordHasNumber &&
        !this.checkMinimunCharacters &&
        !this.checkSpecialCharacters &&
        !this.checkLetters
      return this.changePasswordError.notSafeError
    },
    goToQuestionary() {
      if (this.login.user.email !== this.subscriptionEmail) {
        localStorage.removeItem('firstAccess')
        return this.$router.push({ name: 'Videos' })
      }
      this.$router.push({ name: 'Welcome' })
    },
    handleUpdatePhone(val) {
      this.userPhone = val.formattedNumber
    },
    validatePassword(password) {
      const errors = {
        minError: false,
        notSafeError: false,
        invalidPassword: false,
        limitExceeded: false,
        passwordsNotEqual: false,
      }

      const hasNumber = /\d/.test(password)
      const hasUppercase = /[A-Z]/.test(password)
      const hasLowercase = /[a-z]/.test(password)
      const hasSpecialChar = /[@#$%&]/.test(password)
      const minLength = password.length >= 8

      if (!minLength) {
        errors.minError = true
      }
      if (!hasNumber || !hasUppercase || !hasLowercase || !hasSpecialChar) {
        errors.notSafeError = true
      }
      return errors
    },
    signupPage() {
      this.$router.push({ name: 'SignUp' })
    },
    handleHelp() {
      this.$crisp.push(['do', 'chat:show'])
      this.$crisp.push(['do', 'chat:open'])
    },
    handleWarnByEmail() {
      this.sendType = 'email'
    },
    async handleWarnUser(type) {
      this.sendWarningLoading = true
      this.sendType = type
      let userData = {
        email: this.login.user.email,
        send_option: type === 'number' ? 'phone' : 'email',
        currency: this.currency,
      }
      if (type === 'number') {
        userData['phone'] = this.userPhone
      }
      try {
        const endpoint = `${API_URL}stripe/checkout/?user_notification_created=1`
        await axios.post(endpoint, userData)
        this.sendWarningLoading = false
        this.wasMessageSent = true
      } catch (e) {
        this.sendWarningLoading = false
      }
    },
    removeCrisp() {
      try {
        setTimeout(() => {
          if (this.$crisp) {
            this.$crisp.push(['do', 'chat:hide'])
          }
        }, 1000)
      } catch (e) {
        console.error(e)
        this.removeCrisp()
      }
    },
    async handleCallLogin() {
      const loginData = await this.signInUser({
        username: this.login.user.email,
        password: this.login.user.password,
      })

      this.$root.$emit('updateUser', loginData)
    },
    async handleLogin(ignoreForgetSession) {
      this.trimAllFields()
      Object.keys(this.login.error).forEach(
        (e) => (this.login.error[e] = false)
      )
      if (this.login.user.email === '' || this.login.user.password === '') {
        this.login.error.emptyFields = true
        return
      }
      this.signInLoading = true
      try {
        const loginData = await this.signInUser({
          username: this.login.user.email,
          password: this.login.user.password,
        })
        if (
          ['SOFTWARE_TOKEN_MFA', 'SELECT_MFA_TYPE', 'SMS_MFA'].includes(
            loginData.challengeName
          )
        ) {
          this.$root.$emit('openTwoFactorLoginModal', loginData)
          return
        } else if (loginData.challengeName === 'NEW_PASSWORD_REQUIRED') {
          await this.createStripeUser({
            email: this.login.user.email,
            name: this.login.user.email,
          })
          sessionStorage.setItem('tempAccessKey', this.login.user.password)
          this.firstAccess = true
          localStorage.setItem('firstAccess', true)
          this.UPDATE_FIRST_ACCESS(true)
          this.signInLoading = false
          this.changePasswordCard = true
          return
        }
        this.clearQueryParams()
        this.updateUser({
          email: loginData.attributes.email,
          id: loginData.attributes.sub,
          name: loginData.attributes.email,
        })
        this.$root.$emit('loginUserAppVue')
        sessionStorage.removeItem('tempAccessKey')
        if (this.forgetSessions && !ignoreForgetSession) {
          await this.$store.dispatch('session/forgetSessions', true)
          return this.handleLogin(true)
        }
        await this.setUserInfo(loginData.attributes.sub)
      } catch (error) {
        if (
          error.code === 'NotAuthorizedException' ||
          error.code === 'InvalidParameterException'
        ) {
          this.login.error.invalidAccountError = true
        }
        if (error.code === 'UserNotFoundException') {
          this.login.error.userNotFound = true
        }
        if (error.code === 'PasswordResetRequiredException') {
          this.login.error.resetPasswordRequired = true
        }
        this.login.error.unexpectedError = true
        this.signInLoading = false
        return
      }
      if (this.firstAccess) {
        this.creatingAccount = true
        this.verifyAccount()
        this.sendEvent()
        this.signInLoading = false
        setTimeout(() => {
          this.warningCard = true
        }, 120000)
      } else {
        this.$router.push({ name: 'Videos' })
        this.signInLoading = false
      }
    },
    async setUserInfo(id) {
      try {
        let ret = await organizationApi.getUserById(id)
        this.UPDATE_USER_ALLINFO({ ...ret.data })
      } catch (e) {
        console.log('e', e)
      }
    },
    clearQueryParams() {
      const isBeta = location.search.match('beta')
      const urlSearchParams = new URLSearchParams(window.location.search)
      let url = '/'
      if (isBeta) url += '?beta#/'
      if (urlSearchParams.get('ref')) {
        url += `?ref=${urlSearchParams.get('ref')}&refc=${urlSearchParams.get(
          'refc'
        )}`
      }
      window.history.replaceState({}, document.title, url)
    },
    async createStripeUser({ email, name }) {
      try {
        const endpoint = `${API_URL}stripe/customer`
        await axios.post(endpoint, JSON.stringify({ email, name }))
      } catch (e) {
        console.error(e)
      }
    },
    async handleSendForgetPasswordCode() {
      this.resentCode = false
      this.trimAllFields()
      Object.keys(this.forgetPasswordError).forEach(
        (e) => (this.forgetPasswordError[e] = false)
      )
      if (this.forgetPasswordData.email === '') {
        this.forgetPasswordError.emptyFields = true
        return
      }
      this.emailSent = false
      this.forgetLoading1 = true
      try {
        await this.$store.dispatch('session/forgotPassword', {
          username: this.forgetPasswordData.email,
        })
        this.emailSent = true
        this.forgetLoading1 = false
        this.changePasswordCard = true
        this.forgotPasswordCard = false
      } catch (error) {
        if (
          error.code === 'UserNotFoundException' ||
          error.code === 'InvalidParameterException'
        ) {
          this.forgetPasswordError.invalidAccount = true
        }
        if (error.code === 'NotAuthorizedException') {
          this.forgetPasswordError.currentState = true
          this.handleResendPassword(
            this.forgetPasswordData.email,
            'recover-pass'
          )
        }
        if (error.code === 'LimitExceededException') {
          this.forgetPasswordError.limitExceeded = true
        }
        this.forgetPasswordError.unexpectedError = true
        this.unknownError = error.code
      }
      this.forgetLoading1 = false
    },
    async handleForgetPasswordChangePass() {
      this.unknownError = ''
      this.trimAllFields()
      Object.keys(this.newPasswordError).forEach(
        (e) => (this.newPasswordError[e] = false)
      )
      Object.keys(this.newPasswordError).forEach(
        (e) => (this.newPasswordError[e] = false)
      )
      this.changePasswordLoading = true
      try {
        await this.$store.dispatch('session/changePasswordWithCode', {
          username: this.forgetPasswordData.email,
          code: this.forgetPasswordData.code,
          newPassword: this.changePass.password,
        })
        this.loginAfterPassChange()
        setTimeout(() => {
          this.changePasswordLoading = false
        }, 10000)
      } catch (error) {
        console.error(error)
        this.changePasswordLoading = false
        const anyError = JSON.parse(JSON.stringify(error))
        if (anyError?.message?.includes('Network Error')) {
          this.changePasswordLoading = false
          this.unknownError = 'Code: 500'
          this.newPasswordError.newPasswordError = true
          return
        }
        if (anyError.code === 'InvalidPasswordException') {
          this.newPasswordError.invalidPassword = true
        }
        if (anyError.code === 'LimitExceededException') {
          this.newPasswordError.limitExceeded = true
        }
        if (anyError.code === 'CodeMismatchException') {
          this.newPasswordError.codeMismatchException = true
        }
        if (anyError.code === 'ExpiredCodeException') {
          this.changePasswordError.expiredCode = true
        }
        this.newPasswordError.unexpectedError = true
        this.unknownError = anyError?.code
        return
      }
    },
    async handleChangePass() {
      this.trimAllFields()
      this.changePasswordLoading = true
      if (this.changePass.password === '') {
        this.changePasswordError.notSafeError = true
        this.changePasswordLoading = false
        return
      }
      if (this.changePass.password !== this.changePass.repeatPassword) {
        this.newPasswordError.passwordsNotEqual = true
        this.changePasswordError.passwordsNotEqual = true
        this.changePasswordLoading = false
        return
      }
      if (
        this.changePass.password.length < 8 ||
        this.changePass.repeatPassword < 8
      ) {
        this.changePasswordError.minError = true
        this.changePasswordLoading = false
        return
      }
      try {
        const loginData = await this.signInUser({
          username: this.login.user.email,
          password: this.login.user.password,
        })
        await this.$store.dispatch('session/completePassword', {
          oldUser: loginData,
          newPassword: this.changePass.password,
        })
        this.loginAfterPassChange()
        setTimeout(() => {
          this.changePasswordLoading = false
        }, 3000)
      } catch (error) {
        const anyError = JSON.parse(JSON.stringify(error))
        if (anyError.message.includes('Network Error')) {
          this.changePasswordLoading = false
          this.unknownError = 'Code: 500'
          this.newPasswordError.newPasswordError = true
          return
        }
        if (error.code === 'InvalidPasswordException') {
          this.newPasswordError.invalidPassword = true
        }
        if (error.code === 'LimitExceededException') {
          this.newPasswordError.limitExceeded = true
        }
        if (error.code === 'CodeMismatchException') {
          this.newPasswordError.codeMismatchException = true
        }
        if (error.code === 'InvalidParameterException') {
          this.newPasswordError.parameterException = true
        }
        if (error.code === 'ExpiredCodeException') {
          this.newPasswordError.expiredCode = true
        }
        this.newPasswordError.unexpectedError = true
        this.changePasswordLoading = false
        return
      }
    },
    async handleResendPassword(recoverEmail, type) {
      if (type === 'first-access' && this.login.user.email === '') {
        this.forgetPasswordError.invalidAccount = true
        return
      }
      this.trimAllFields()
      this.resentLoading = true
      try {
        const endpoint = `${API_URL}user/resend-password`
        await axios.post(endpoint, JSON.stringify({ email: recoverEmail }))
        if (type === 'recover-pass') {
          this.resentCode = true
        } else {
          this.resentCodeFirst = true
        }
        this.changePasswordCard = false
        this.forgotPasswordCard = false
        this.firstAccess = true
        localStorage.setItem('firstAccess', true)
        this.login.user.email = recoverEmail
        Object.keys(this.forgetPasswordError).forEach(
          (e) => (this.forgetPasswordError[e] = false)
        )
        Object.keys(this.changePasswordError).forEach(
          (e) => (this.changePasswordError[e] = false)
        )
        Object.keys(this.newPasswordError).forEach(
          (e) => (this.newPasswordError[e] = false)
        )
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          text: i18n.t('message.pages.login.codeEmailSuccessResend'),
          type: 'success',
        })
      } catch (error) {
        this.resentLoading = false
        if (
          error.code === 'UserNotFoundException' ||
          error.code === 'InvalidParameterException'
        ) {
          this.forgetPasswordError.invalidAccount = true
        }
        if (error.code === 'NotAuthorizedException') {
          this.forgetPasswordError.currentState = true
        }
        if (error.code === 'LimitExceededException') {
          this.forgetPasswordError.limitExceeded = true
        }
        this.forgetPasswordError.unexpectedError = true
        this.unknownError = ` Error: ${error.response.data.errMsg}.`
      }
      this.resentLoading = false
    },
    handleTryAgainCode() {
      this.emailSent = false
      this.forgetLoading1 = false
    },
    loginAfterPassChange() {
      if (this.firstAccess) {
        this.login.user.password = this.changePass.password
      } else {
        this.login.user.email = this.forgetPasswordData.email
        this.login.user.password = this.changePass.password
      }
      this.handleLogin()
    },
    handleForgetPassword() {
      Object.keys(this.forgetPasswordError).forEach(
        (e) => (this.forgetPasswordError[e] = false)
      )
      Object.keys(this.login.error).forEach(
        (e) => (this.login.error[e] = false)
      )
      this.forgetPasswordData.email = this.login.user.email
      this.forgotPasswordCard = true
    },
    cancelChangePassword() {
      this.changePasswordCard = false
      this.changePasswordLoading = false
      Object.keys(this.changePasswordError).forEach(
        (e) => (this.changePasswordError[e] = false)
      )
      Object.keys(this.changePass).forEach((e) => (this.changePass[e] = ''))
    },
    cancelForgetPassword() {
      this.forgetPasswordStep = 1
      this.login.user.password = ''
      Object.keys(this.forgetPasswordError).forEach(
        (e) => (this.forgetPasswordError[e] = false)
      )
      Object.keys(this.newPasswordError).forEach(
        (e) => (this.newPasswordError[e] = false)
      )
      Object.keys(this.forgetPasswordData).forEach(
        (e) => (this.forgetPasswordData[e] = '')
      )
      this.forgotPasswordCard = false
    },
    handleRouteToHomepage() {
      window.location.replace('https://www.pandavideo.com.br/')
    },
    queryParamsObj() {
      var result = {},
        keyValuePairs = location.search.slice(1).split('&')
      keyValuePairs.forEach(function (keyValuePair) {
        keyValuePair = keyValuePair.split('=')
        result[decodeURIComponent(keyValuePair[0])] =
          decodeURIComponent(keyValuePair[1]) || ''
      })
      return result
    },
    trimAllFields() {
      Object.keys(this.login.user).forEach(
        (e) => (this.login.user[e] = this.login.user[e].trim())
      )
      Object.keys(this.changePass).forEach(
        (e) => (this.changePass[e] = this.changePass[e].trim())
      )
      Object.keys(this.forgetPasswordData).forEach(
        (e) => (this.forgetPasswordData[e] = this.forgetPasswordData[e].trim())
      )
    },
    handleEnterOnPass() {
      this.firstAccess
        ? this.handleChangePass()
        : this.handleForgetPasswordChangePass()
    },
    checkIfBothPasswordAreEqual() {
      if (
        this.changePass.password !== this.changePass.repeatPassword &&
        this.changePass.password !== ''
      ) {
        this.newPasswordError.passwordsNotEqual = true
        return
      }
      return (this.newPasswordError.passwordsNotEqual = false)
    },
    async sendEvent() {
      try {
        const subscription = await this.checkStripe()
        let planVal = subscription.data.subscriptions.unit_amount / 100

        // eslint-disable-next-line
        fbq('track', 'StartTrial', {
          value: planVal,
          currency: subscription.data.currency,
        })
        // eslint-disable-next-line
        gtag('event', 'StartTrial', {
          email: this.$store.state.user.userInfo.email,
          value: planVal,
          currency: subscription.data.currency,
        })
        window.dataLayer.push({
          event: 'signup_completed',
          plan_name: subscription.data.subscriptions.name,
          plan_value: planVal,
        })
        await facebookConversionApi.PurchaseEvent({
          currency: this.isDomainFromBrazil ? 'BRL' : 'USD',
          email: this.$store.state.user.userInfo.email,
          plan_name: subscription.data.subscriptions.name,
          plan_value: planVal,
        })
      } catch (e) {
        console.log(e + 'Error sending events')
      }
    },
    async verifyAccount() {
      if (!this.alreadyCreated) {
        const subscription = await this.checkStripe()
        this.subscriptionEmail = subscription.data.email
        if ((await this.checkLibrary()) && subscription) {
          this.alreadyCreated = true
          try {
            this.planAmount = subscription.data.subscriptions.unit_amount / 100
            this.currency = subscription.data.currency
          } catch {
            this.planAmount = 0
          }
        }
        setTimeout(() => {
          this.verifyAccount()
        }, 2000)
      } else {
        if (this.login.user.email !== this.subscriptionEmail) {
          localStorage.removeItem('firstAccess')
        }
      }
    },
    async checkLibrary() {
      try {
        await videosApi.getVideos()
        return true
      } catch (e) {
        return false
      }
    },
    async checkStripe() {
      try {
        return await planApi.getSubscription()
      } catch (e) {
        return false
      }
    },
  },
  beforeDestroy() {
    this.$root.$off('callLogin', this.handleCallLogin)
  },
  beforeMount() {
    let params = location.search
      .slice(1)
      .split('&')
      .map((p) => p.split('='))
      .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {})
    let accessType = params.type
    if (accessType === 'first-access' && params.email) {
      this.firstAccess = true
      localStorage.setItem('firstAccess', true)
      this.login.user.email = params.email
    }
  },
}
</script>

<style lang="scss">
.iconFooter .v-image__image {
  width: 18px;
}

.welcomeText {
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  @media only screen and (max-width: 960px) {
    font-size: 22px;
  }
}

.welcomeTextFirstAccess {
  font-weight: 500;
  font-size: 24px;
  line-height: 28.8px;
  color: $neutral-20-dark-light;
}

.theme--dark .welcomeTextFirstAccess {
  color: $neutral-90-light;
}

.subTextFirstAccess {
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: $neutral-40-light-light;
}

.theme--dark {
  .helpLinks {
    color: $neutral-40-light-dark !important;
  }
}
.helpLinks {
  color: $neutral-30-base-light;
  line-height: 150%;
  text-decoration: none;
  font: {
    size: $spacing-minus-1;
    style: normal;
    weight: 500;
  }
}
.theme--dark .subTextFirstAccess {
  color: $neutral-40-light-dark;
}

.createPassword,
.confirmEmailCard {
  background-color: $color-neutral-white;
}

.theme--dark .createPassword,
.theme--dark .confirmEmailCard {
  background-color: $neutral-100-white-dark;
}

.confirmEmailStepBackground {
  background: linear-gradient(90deg, $color-brand 0%, #8594ff 100%);
}
.theme--dark .confirmEmailStepBackground {
  background: linear-gradient(90deg, #070f4b 0%, #000f75 100%);
}

.theme--dark .cardPasswordMustHave {
  background-color: $neutral-99-dark;
}
.theme--light .cardPasswordMustHave {
  background-color: $neutral-99-light;
}

.attributesTextFirstAccess {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  color: $neutral-20-dark-light;
  line-height: 150%;
}
.theme--dark .attributesTextFirstAccess {
  color: $neutral-20-dark-dark;
}

.imgCardFirstAccess {
  max-width: 438px;
  max-height: 412px;
  flex-shrink: 0;
}

.lightModeColor {
  color: var(--v-brand-darken1) !important;
}

.subtitleText {
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.04em;
  color: #878787;
  @media only screen and (max-width: 960px) {
    font-size: 12px;
  }
}

.orText {
  color: #d6d6d6;
  font-size: 13px;
  line-height: 19px;
  letter-spacing: 0.05em;
}

.textButton {
  background: none;
  border: none;
  font-size: 0.9375rem;
  font-weight: 400;
  line-height: 1;
}

.footerText {
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 0.05em;
  @media only screen and (max-width: 960px) {
    font-size: 9px;
  }
}

.attributesText {
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.05em;
}

.fontWeightSubtitle {
  font-weight: 400;
}

.subtitleMarginBottom {
  margin-bottom: 6px;
}

.codeInput {
  max-width: 56px;
  height: 70px;
}

.requirementsText {
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: #878787;
}

.codeText {
  font-weight: 600;
  font-size: 28px;
  line-height: 42px;
}

.attributesText {
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
}

.wrapText {
  word-break: keep-all;
}

.carroselCard {
  @media only screen and (max-width: 960px) {
    padding: 10px 0px;
  }
}

.termsFont {
  font-size: 14px;
  @media only screen and (max-width: 960px) {
    font-size: 11px !important;
  }
}
.steps {
  font-weight: 400;
  font-size: 20px;
  line-height: 120%;
  @media only screen and (max-width: 960px) {
    font-size: 13px;
    line-height: 150%;
  }
}
.mustHaveText {
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #585d83;
}

.welcomePandaIcon {
  -webkit-animation: scale-in-center 1.2s cubic-bezier(0.25, 0.46, 0.45, 0.94)
    both;
  animation: scale-in-center 1.2s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

.prepAccount {
  font-weight: 500;
  font-size: 40px;
  line-height: 48px;
  word-wrap: break-word;
  color: $neutral-100-white-light;
  -webkit-animation: slide-in-bottom 1.2s cubic-bezier(0.25, 0.46, 0.45, 0.94)
    both;
  animation: slide-in-bottom 1.2s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  @media only screen and (max-width: 960px) {
    margin: 0 1.5rem;
  }
}

.subText {
  max-width: 550px;
  font-weight: 400;
  font-size: 20px;
  font-style: normal;
  line-height: 24px;
  display: flex;
  text-align: center;
  align-items: center;
  color: $brand-95-lighter-light;
  word-break: break-word;
  -webkit-animation: slide-in-bottom 1.2s cubic-bezier(0.25, 0.46, 0.45, 0.94)
    both;
  animation: slide-in-bottom 1.2s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  @media only screen and (max-width: 960px) {
    font-weight: 400;
    font-size: 20px;
    margin: 0 1.2rem;
  }
}
.startBtn {
  -webkit-animation: slide-in-bottom 2.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)
    both;
  animation: slide-in-bottom 2.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}
.helpLinks {
  font-weight: 400;
  font-size: 14px;
  text-decoration: none !important;
}
.loginCard {
  border: 1px solid #e6e8f8 !important;
  border-radius: 4px !important;
}
.warningTitle {
  font-weight: 500;
  font-size: 20px;
  line-height: 120%;
  color: var(--v-brand-darken2);
}
.warningSubtitle {
  font-weight: 400;
  font-size: 18px;
}
.warningWhatsapp {
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
}
.emailSentText {
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: var(--v-neutral-base);
}
.warningEmail {
  font-weight: 500;
  font-size: 12px;
  line-height: 100%;
  color: #3f55ee;
}
.whatsappSelect {
  border: none !important;
}

.bg-dark,
.theme--dark {
  $colorDark: #70a5f2 !important;

  .steps {
    color: $colorDark;

    &__container {
      .v-icon {
        color: $colorDark;
      }
    }
  }

  .warningTitle {
    color: #8fb1e3;
  }

  .lightModeColor {
    color: #70a5f2 !important;
  }
}

@-webkit-keyframes scale-in-center {
  0% {
    width: 142px;
    margin-top: 100px;
    -webkit-transform: scale(0);
    transform: scale(0);
    opacity: 0;
  }
  50% {
    width: 142px;
    margin-top: 100px;
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 1;
  }
  60% {
    width: 142px;
    margin-top: 100px;
  }
  100% {
    width: 77px;
    margin-top: 0px;
  }
}
@keyframes scale-in-center {
  0% {
    width: 142px;
    margin-top: 100px;
    -webkit-transform: scale(0);
    transform: scale(0);
    opacity: 0;
  }
  50% {
    width: 142px;
    margin-top: 100px;
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 1;
  }
  60% {
    width: 142px;
    margin-top: 100px;
  }
  100% {
    width: 77px;
    margin-top: 0px;
  }
}
@-webkit-keyframes slide-in-bottom {
  0% {
    -webkit-transform: translateY(50px);
    transform: translateY(50px);
    opacity: 0;
  }
  70% {
    -webkit-transform: translateY(50px);
    transform: translateY(50px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slide-in-bottom {
  0% {
    -webkit-transform: translateY(50px);
    transform: translateY(50px);
    opacity: 0;
  }
  60% {
    -webkit-transform: translateY(50px);
    transform: translateY(50px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
